export const newAccelerationButton = {
  fontSize: 'bodySmallStandard',
  fontWeight: '$regular',
  textTransform: 'uppercase'
}

export const newAccelerationContainer = {
  marginBottom: '$6',
  flexDirection: 'column',
  gap: '$4',
  '@desktop': {
    flexDirection: 'row',
    justifyContent: 'space-between'
  }
}
